module.exports = __webpack_public_path__ + "pc/img/body_basic-3.897fa2c8.png";